<template>
	<v-container fluid class="grey lighten-5">
		<v-container grid-list-lg>
			<v-row>
				<v-col>
					<h1 class="font-weight-black black--text text-xs-center">نسخه های پازار 12</h1>
				</v-col>
			</v-row>
			<v-row justify-center row wrap class="good-cards">
				<v-col xs="12" sm="6" v-for="(item, idx) in v12Types" :key="idx">
					<v-hover>
						<v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
							<v-responsive>
								<v-img :src="item.image" height="300px"> </v-img>
							</v-responsive>
							<v-card-text>
								<div>
									<h2 class="font-weight-black black--text text-xs-center mb-1">{{ item.text }}</h2>
								</div>
								<v-divider></v-divider>
								<h3 class="font-weight-thin black--text mb-1">{{ item.desc }}</h3>
								<br />
								<h1 class="font-weight-bold black--text text-left mb-1">{{ item.price }}</h1>
							</v-card-text>

							<v-card-actions>
								<v-btn text color="grey darken-2 " class="font-weight-thin black--text text-xs-center mb-0" :to="item.info">اطلاعات بیشتر</v-btn>
								<v-spacer></v-spacer>
								<v-btn text color="grey darken-2" class="font-weight-thin black--text text-xs-center mb-0" :to="item.link">خرید</v-btn>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</v-container>
		<p>&nbsp;</p>
	</v-container>
</template>

<script>
	export default {
		name: "V12Cards",
		computed: {
			v12Types() {
				return this.$store.state.v12Types;
			},
		},
	};
</script>
